import React from 'react';
import {GoogleLogin} from 'react-google-login';

import './Login.scss';
import {clientId} from './config/googleClientId';

export default function Login({onSuccess, onFailure}:any) {
    return (
        <div className="login-container ">
            <div className="login-container__login-button">
                <GoogleLogin
                    clientId={clientId}
                    buttonText="Login with Pluto account"
                    onSuccess={onSuccess}
                    onFailure={onFailure}
                    isSignedIn
                    responseType="token"
                    cookiePolicy="single_host_origin"
                />
            </div>
        </div>
    );
}
